import { render, staticRenderFns } from "./videoView.vue?vue&type=template&id=40236520&scoped=true&"
import script from "./videoView.vue?vue&type=script&lang=js&"
export * from "./videoView.vue?vue&type=script&lang=js&"
import style0 from "./videoView.vue?vue&type=style&index=0&id=40236520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40236520",
  null
  
)

export default component.exports